import React from 'react';
import {
    Container, Btn, Box, H3, P,
    Grid,
} from '@saladbob/sassafras'

import Link from 'next/link';

import StaffCard from '../../cards/StaffCard';
import Carousel from '../../media/Carousel';
import { Block } from '../../../types';

const Staff: React.FC<Block> = ({
    staff,
    title,
    subtitle,
    contain,
    verticalPadding: vp,
    horizontalPadding: hp,
    mb = '0',
    bgColor,
    txtColor,
    minHeight,
}) => {
    return (
        <Box
            minHeight={minHeight}
            mb={mb}
            padding={{ phone: [vp, hp ? 'md' : 0], laptop: [vp, hp] }}
            bgColor={bgColor}
            justify="center"
            align="center"
            style={{
                backgroundAttachment: 'fixed',
            }}
        >
            <Container size={contain} height="min-content">
                <Box mb={{ phone: 'md', laptop: 'xl' }}>
                    {title && (<H3 color={txtColor} font={'h1'} mb="sm" uppercase align="center">{title}</H3>)}
                    {subtitle && (<P color={txtColor} font={'leader' } align="center">{subtitle}</P>)}
                </Box>
                <Grid columns={`repeat(${staff.length}, 1fr)`} gridGap="xxl" justify="center" maxWidth="max-content" margin="0 auto">
                    {staff.map((staff) => (
                        <Box key={staff.id}>
                            <StaffCard staff={staff} txtColor={txtColor} maxWidth="600px" />
                        </Box>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}

export default Staff;
